import { useState } from 'react'
import { Field, ErrorMessage } from 'formik'
import FieldWrapper from '../../FieldWrapper'
import MultiselectCheckboxAttributes from '../MultiselectCheckboxAttributes'
import WrapperAccordion from '../../../general/WrapperAccordion'
import config from '../../../../attribute-position-config.json'
import RadioButtonGroup from '../RadioButtonGroup'
import RadioButton from '../SingleSelectRadiobutton'
import DatePickerContainer from '../DatepickerContainer'
import DateTimePickerContainer from '../DateTimePickerContainer'
import Translation from '../../../Translation/cont/Translation'
import SourceField from '../SourceField'
import ImageDisplayAndUpload from '../ImageDisplayAndUpload'
import EditActorsModal from './EditActorsModal'
import MovieURL from '../../../../containers/general/MovieURL'
import decodeHtml from '../../../../functions/decodeHtml'
import { ORIGIN_TMDB, ORIGIN_DATA_PROVIDER, ORIGIN_PM } from '../../../../constants/metaMovieOrigins'

const ACTORS_VISIBLE = 15

const getFskStyle = (fsk) => {
    const styles = {
        0:  { color: '#fff',    bg: 'rgba(255,255,255,0.08)', shadow: '#fff' },
        3:  { color: '#f5c800', bg: 'rgba(245,200,0,0.1)',    shadow: '#f5c800' },
        6:  { color: '#ffd200', bg: 'rgba(255,210,0,0.1)',    shadow: '#ffd200' },
        8:  { color: '#f5c800', bg: 'rgba(245,200,0,0.1)',    shadow: '#f5c800' },
        12: { color: '#3ab83a', bg: 'rgba(58,184,58,0.1)',    shadow: '#3ab83a' },
        16: { color: '#5577dd', bg: 'rgba(85,119,221,0.12)',  shadow: '#5577dd' },
        18: { color: '#dd3344', bg: 'rgba(221,51,68,0.12)',   shadow: '#dd3344' },
    }
    const s = styles[fsk]
    if (!s) return {}
    return { color: s.color, background: s.bg, boxShadow: `1px 1px ${s.shadow}, -1px -1px ${s.shadow}, -1px 1px ${s.shadow}, 1px -1px ${s.shadow}` }
}

const InformationAccordion = ({values, activeTabClass, setActiveTab, title, setFieldValue, classes, metaData, hasCountdownMovie, onChange, onReset, isTmdbLinked, hasPreviewMovie, hasProviderMovie, isCompesoProvider, onSetOrigin, translationStrings, currentLang, timezone}) => {
    const [showAllActors, setShowAllActors] = useState(false)
    const [showActorsModal, setShowActorsModal] = useState(false)
    const [visibleFromReset, setVisibleFromReset] = useState(false)
    const onLogoChange = onChange('logo')
    const setDateFieldAndOrigin = key => (name, value) => {
        setFieldValue(name, value)
        onChange(key)()
    }
    const logoSources = [
        ...(isTmdbLinked ? [ORIGIN_TMDB] : []),
        ORIGIN_PM,
    ]
    const threeSourced = [
        ...(isTmdbLinked ? [ORIGIN_TMDB] : []),
        ...(hasProviderMovie ? [ORIGIN_DATA_PROVIDER] : []),
        ORIGIN_PM,
    ]
    const titleSources = [
        ...(hasProviderMovie ? [ORIGIN_DATA_PROVIDER] : []),
        ORIGIN_TMDB,
    ]
    const actorsSources = [
        ...(hasProviderMovie ? [ORIGIN_DATA_PROVIDER] : []),
        ...(isTmdbLinked ? [ORIGIN_TMDB] : []),
        ORIGIN_PM,
    ]
    const originalTitleSources = [
        ...(isTmdbLinked ? [ORIGIN_TMDB] : []),
        ...(hasProviderMovie ? [ORIGIN_DATA_PROVIDER] : []),
        ORIGIN_PM,
    ]
    const startingDateSources = [
        ...(isTmdbLinked ? [ORIGIN_TMDB] : []),
        ...(hasProviderMovie ? [ORIGIN_DATA_PROVIDER] : []),
        ORIGIN_PM,
    ]
    const fsk = values.movie.fsk
    const actors = values.movie.actors || []
    const directors = values.movie.directors || []
    const visibleActors = showAllActors ? actors : actors.slice(0, ACTORS_VISIBLE)
    const hiddenCount = actors.length - ACTORS_VISIBLE

    return (
    <WrapperAccordion
        title={title}
        className={classes}
        selectionActiveClass={activeTabClass}
        collapseActiveSelection={setActiveTab}
        gapless={true}
    >
        <fieldset>
            <div className="form-content">
                <div className="left-sections">
                    <FieldWrapper label={<Translation id="movie_edit_movie_logo" />} id="movie-logo" classes="field-wrapper-image-accordion" wrapperClasses="image-wrapper">
                        <Field name="movie.logo" imageType="logo" component={ImageDisplayAndUpload} onChange={onLogoChange} autoUpload={true} />
                        {metaData && onSetOrigin && isTmdbLinked && (
                            <SourceField metaKey="logo" metaValue={metaData.logo} sources={logoSources} onSetOrigin={onSetOrigin} />
                        )}
                    </FieldWrapper>

                    <FieldWrapper label={<Translation id="movie_edit_movie_title" />} id="movie-title" classes="field-text">
                        <p id="movie-title" className="text-regular input-text-box">{values.movie.title}</p>
                        {metaData && onSetOrigin && isTmdbLinked && (
                            <SourceField metaKey="title" metaValue={metaData.title} sources={titleSources} onSetOrigin={onSetOrigin} />
                        )}
                    </FieldWrapper>

                    <FieldWrapper label={<Translation id="movie_edit_movie_title_display"/>} id="movie-title-display" classes="field-text">
                        <Field type="text" name="movie.titleDisplay" id="movie-title-display" className="text-regular input-text-box" />
                        <ErrorMessage name="movie.titleDisplay" component="div" id="movie-title-display"/>
                    </FieldWrapper>
                    
                    <FieldWrapper label={<Translation id="movie_edit_movie_additional_text"/>} info={<Translation id="movie_edit_movie_additional_text_info"/>} id="movie-subtitle" classes="field-textarea field-textarea-text">
                        <Field component="textarea" name="movie.subTitle" cols="50" wrap="hard" rows="1" id="movie-subtitle" className="text-regular input-text-box" maxLength="70"/>
                        <ErrorMessage name="movie.subTitle" component="div" id="movie-subtitle"/> 
                    </FieldWrapper>
                    
                    <FieldWrapper label={<Translation id="movie_edit_movie_short_description" />} info={<Translation id="movie_edit_movie_short_description_info"/>} id="movie-description-short" classes="field-textarea field-textarea-text">
                        <Field name="movie.descriptionShort" component="textarea" cols="50" wrap="hard" maxLength="220" id="movie-description-short" className="text-small-light input-text-box" />
                        <ErrorMessage name="movie.descriptionShort" component="div" />
                    </FieldWrapper>

                    <FieldWrapper label={<Translation id="movie_edit_movie_description"/>} id="movie-description" classes="field-textarea field-textarea-text">
                        <Field name="movie.description" component="textarea" cols="50" wrap="hard" id="movie-description" className="text-small-light input-text-box" onChange = {onChange('description')} />
                        {metaData && onSetOrigin && (
                            <SourceField metaKey="description" metaValue={metaData.description} sources={threeSourced} onSetOrigin={onSetOrigin} />
                        )}
                        <ErrorMessage name="movie.description" component="div" />
                    </FieldWrapper>
                    
                    {_.has(values.movie, 'posterAttribute') && <FieldWrapper label={<Translation id="movie_edit_movie_poster_attribute"/>} info={<Translation id="movie_edit_movie_poster_attribute_info"/>} id="movie-posterattribute" classes="field-text">
                        <Field name="movie.posterAttribute.name" type="text" maxLength="20" id="movie-posterattribute" className="text-small-light input-text-box" />
                        <ErrorMessage name="movie.posterAttribute.name" component="div" />
                    </FieldWrapper>}
                    {_.has(values.movie, 'posterAttribute') && <RadioButtonGroup
                        label={<Translation id="movie_edit_movie_position"/>}
                        className="select-new-section-type attribute-position"
                    >
                        {config.positions.map(position => {
                            const {transId, id} = position
                            return (
                                <Field
                                    key={id}
                                    component={RadioButton}
                                    name="movie.posterAttribute.position"
                                    id={id}
                                    label={<Translation id={transId}/>}
                                    setFieldValue={setFieldValue}
                                />
                            )
                        })}
                    </RadioButtonGroup>}
                </div>

                <div className="right-sections">
                    <fieldset className="field-category field-genres">
                        <legend className="text-small-light"><Translation id="movie_edit_movie_genres"/></legend>

                        <div className="grid-container">
                            {Object.keys(values.attributes.global.genres).map(attrId => {
                                return (
                                    <div key={'field' + attrId} className="field-checkbox">
                                        <Field 
                                            key={attrId} 
                                            type="genres"
                                            attrid={attrId}
                                            movieid={values.movie.id}
                                            name={"movie.genres"} 
                                            component={MultiselectCheckboxAttributes} 
                                            value={values.attributes.global.genres[attrId]} 
                                            onClick={onChange('genres')}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                        {metaData && onSetOrigin && (
                            <SourceField metaKey="genres" metaValue={metaData.genres} sources={threeSourced} onSetOrigin={onSetOrigin} />
                        )}
                    </fieldset>

                    <FieldWrapper label={<Translation id="movie_edit_movie_trailer"/>} id="movie-trailer" info={<Translation id="movie_edit_movie_trailer_info"/>} classes="field-text">
                        <Field type="url" name="movie.trailerURL" className="text-regular input-text-box" onChange = {onChange('trailerURL')} />
                        {metaData && onSetOrigin && (
                            <SourceField metaKey="trailerURL" metaValue={metaData.trailerURL} sources={threeSourced} onSetOrigin={onSetOrigin} />
                        )}
                        <ErrorMessage name="movie.trailerURL" component="div" id="movie-trailer"/> 
                    </FieldWrapper>

                    <div className="datepicker-container">
                        <div className="datepicker-wrapper starting-date">
                            <FieldWrapper label={<Translation id="preview_movies_expected_startdate_label" />} info={<Translation id="preview_movies_expected_startdate_info" />} id="movie-startingdate" classes="datepicker-inner-wrapper">
                                <DatePickerContainer
                                    name="movie.startingDate"
                                    value={values.movie.startingDate || ''}
                                    onChange={setDateFieldAndOrigin('starting_date')}
                                    id="movie-startingdate"
                                    className="text-small-light input-text-box"
                                />
                            </FieldWrapper>
                            {metaData && onSetOrigin && (
                                <SourceField metaKey="starting_date" metaValue={metaData.starting_date} sources={startingDateSources} onSetOrigin={onSetOrigin} />
                            )}
                        </div>
                    </div>

                    {hasPreviewMovie && (
                        <div className="datepicker-wrapper">
                            <FieldWrapper label={<Translation id="preview_movies_start_date_description_label" />} info={<Translation id="preview_movies_start_date_description_info" />} id="movie-startdatedescription" classes="datepicker-inner-wrapper">
                                <Field type="text" name="movie.startDateDescription" id="movie-startdatedescription" className="text-small-light input-text-box" />
                            </FieldWrapper>
                        </div>
                    )}

                    <div className="datepicker-container">
                        <div className="datepicker-wrapper">
                            <FieldWrapper label={<Translation id="movie_edit_movie_visible_from_label" />} id="movie-visiblefrom" classes="datepicker-inner-wrapper">
                                <DateTimePickerContainer
                                    name="movie.limitations.visibleFrom"
                                    value={values.movie.limitations ? values.movie.limitations.visibleFrom : null}
                                    onChange={setDateFieldAndOrigin('visible_from')}
                                    timezone={timezone}
                                    id="movie-visiblefrom"
                                    className="text-small-light input-text-box"
                                    translationStrings={translationStrings}
                                    currentLang={currentLang}
                                    disabled={visibleFromReset}
                                />
                            </FieldWrapper>
                            {metaData && onSetOrigin && isCompesoProvider && (
                                <div className="source-field source-field--pills">
                                    <button
                                        type="button"
                                        className={'source-pill source-pill--ks' + (metaData.visible_from === ORIGIN_DATA_PROVIDER ? ' source-pill--active' : '')}
                                        onClick={() => { onSetOrigin('visible_from', ORIGIN_DATA_PROVIDER); setVisibleFromReset(true) }}
                                    >
                                        {metaData.visible_from === ORIGIN_DATA_PROVIDER
                                            ? <Translation id="source_ks" />
                                            : <Translation id="visible_from_reset_button" />}
                                    </button>
                                    <button
                                        type="button"
                                        disabled={visibleFromReset}
                                        className={'source-pill source-pill--pm' + (metaData.visible_from === ORIGIN_PM ? ' source-pill--active' : '')}
                                        onClick={() => onSetOrigin('visible_from', ORIGIN_PM)}
                                    >
                                        <Translation id="source_pm" />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    {hasCountdownMovie && <div className='field-text'>
                        <label>
                            <p className='gap-10'><Translation id="movie_edit_movie_countdown">Countdown anzeigen</Translation></p>
                        
                            <Field type="checkbox" checked={values.movie.showCountdown} id="active-title-top-text" className="checkbox tgl tgl-flat" onChange={() => {
                                setFieldValue('movie.showCountdown', !values.movie.showCountdown)
                            }}/>
                            <span className="tgl-btn text-regular"><span className='screen-reader-text'><Translation id="print_flyer_activate_customization">Aktiv</Translation></span></span>
                        </label>
                    </div>}

                    <div className="fsk-length-badges">
                        {fsk !== undefined && fsk !== null && fsk !== -1 && (
                            <span className="fsk-badge" style={getFskStyle(fsk)}>FSK {fsk}</span>
                        )}
                        {!!values.movie.length && (
                            <span className="length-badge">
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
                                </svg>
                                {values.movie.length} min
                            </span>
                        )}
                    </div>

                    <div className="movie-meta-grid">
                        {directors.length > 0 && (
                            <div className="mmc mmc--span2">
                                <span className="mmc-label"><Translation id="movie_attributes_directing" /></span>
                                <span className="mmc-value">{directors.map(d => d.name).join(', ')}</span>
                            </div>
                        )}
                        {values.movie.productionYear && (
                            <div className="mmc">
                                <span className="mmc-label"><Translation id="movie_attributes_orig_year" /></span>
                                <span className="mmc-value">{values.movie.productionYear}</span>
                            </div>
                        )}
                        {values.movie.productionCountry && values.movie.productionCountry.length > 0 && (
                            <div className="mmc mmc--span3">
                                <span className="mmc-label"><Translation id="movie_attributes_orig_country" /></span>
                                <span className="mmc-value">
                                    {Array.isArray(values.movie.productionCountry)
                                        ? values.movie.productionCountry.join(', ')
                                        : values.movie.productionCountry}
                                </span>
                            </div>
                        )}
                        {values.movie.id && (
                            <div className="mmc mmc--span3">
                                <span className="mmc-label"><Translation id="movie_attributes_orig_id" /></span>
                                <span className="mmc-value">{values.movie.id}</span>
                            </div>
                        )}
                        <div className="mmc mmc--span3">
                            <span className="mmc-label">URL</span>
                            <MovieURL movieId={values.movie.id} bare />
                        </div>
                    </div>

                    <FieldWrapper label={<Translation id="movie_attributes_orig_title" />} id="movie-orig-title" classes="field-text">
                        {metaData && metaData.original_title === ORIGIN_PM
                            ? <Field type="text" name="movie.origTitle" id="movie-orig-title" className="text-regular input-text-box" />
                            : <p id="movie-orig-title" className="text-regular input-text-box">{values.movie.origTitle ? decodeHtml(values.movie.origTitle) : ''}</p>
                        }
                        {metaData && onSetOrigin && (
                            <SourceField metaKey="original_title" metaValue={metaData.original_title} sources={originalTitleSources} onSetOrigin={onSetOrigin} />
                        )}
                    </FieldWrapper>

                    {(actors.length > 0 || (metaData && metaData.actors === ORIGIN_PM)) && (
                        <div className="actor-chips-block">
                            <span className="field-text-label"><Translation id="movie_attributes_orig_actors" /></span>
                            {actors.length > 0 && (
                                <div className="actor-chips-wrap">
                                    {visibleActors.map((actor, i) => (
                                        <span key={i} className="actor-chip">{decodeHtml(actor.name)}</span>
                                    ))}
                                </div>
                            )}
                            {actors.length > ACTORS_VISIBLE && (
                                <button className="actors-toggle-btn" type="button" onClick={() => setShowAllActors(s => !s)}>
                                    {showAllActors
                                        ? '– weniger anzeigen'
                                        : `+ ${hiddenCount} weitere anzeigen`}
                                </button>
                            )}
                            {metaData && onSetOrigin && (
                                <SourceField metaKey="actors" metaValue={metaData.actors} sources={actorsSources} onSetOrigin={onSetOrigin} />
                            )}
                            {metaData && metaData.actors === ORIGIN_PM && (
                                <button className="button" type="button" onClick={() => setShowActorsModal(true)}>
                                    <Translation id="movie_edit_movie_actors_edit_button" />
                                </button>
                            )}
                            {showActorsModal && (
                                <EditActorsModal
                                    actors={actors}
                                    translationStrings={translationStrings}
                                    currentLang={currentLang}
                                    onSave={(newActors) => { setFieldValue('movie.actors', newActors); setShowActorsModal(false) }}
                                    onClose={() => setShowActorsModal(false)}
                                />
                            )}
                        </div>
                    )}

                    <div className="datepicker-container">
                        <div className="datepicker-wrapper">
                            {values.movie.displayDates && <FieldWrapper label={<Translation id="movie_edit_movie_display_start_date"/>} description={<Translation id="movie_edit_movie_display_start_date_info"/>} id="movie-startdate" classes="datepicker-inner-wrapper">
                                <DatePickerContainer value={values.movie.displayDates.start} isStartDate={true} resetValue={'movie.displayDates.end'} end={values.movie.displayDates.end} name="movie.displayDates.start" onChange={setFieldValue} type="text" id="movie-startdate" className="text-small-light input-text-box" />
                                <ErrorMessage name="movie.displayDates.start" component="div" />
                            </FieldWrapper>}
                        </div>
                        <div className="datepicker-wrapper">
                            {values.movie.displayDates && <FieldWrapper label={<Translation id="movie_edit_movie_display_end_date"/>} description={<Translation id="movie_edit_movie_display_end_date_info"/>} id="movie-enddate" classes="datepicker-inner-wrapper">
                                <DatePickerContainer value={values.movie.displayDates.end} start={values.movie.displayDates.start} name="movie.displayDates.end" onChange={setFieldValue} type="text" id="movie-enddate" className="text-small-light input-text-box" />
                                <ErrorMessage name="movie.displayDates.end" component="div" />
                            </FieldWrapper>}
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
    </WrapperAccordion>
    )
}

export default InformationAccordion